// Get the modal
const modal = document.getElementById("trailerModal");

// Get the button that opens the modal
const btn = document.getElementById("trailerBtn");

// Get the <span> element that closes the modal
const span = document.querySelector('.modal-close');

const video = document.querySelector('video');

// When the user clicks on the button, open the modal
btn.onclick = function() {
  modal.style.display = "flex";
};

// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  _closeTrailerModal();
};

span.addEventListener('keyup', e => {
  if (e.key === 'Enter') _closeTrailerModal();
});

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) _closeTrailerModal();
};

window.addEventListener('keyup', e => {
  if (e.key === 'Escape' && modal.style.display === 'flex') {
    _closeTrailerModal();
  }
});

if (video) video.addEventListener('keyup', e => {
  if (e.key === 'Escape') _closeTrailerModal();
});

function _closeTrailerModal () {
  if (video) video.pause();
  modal.style.display = 'none';
  btn.focus();
};
